import styled from '@emotion/styled';
import { Icon, Link } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';

import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import UpgradePlanModal from '@/components/Modals/UpgradePlanModal';
import { pricingPageUrl } from '@/environment';
import Crown from '@/images/Crown.svg';
import voicePremiumUpgrade from '@/images/upgrades/voicePremiumUpgrade.svg';
import { useAnalytics } from '@/services/analytics';
import { InlineToast } from './InlineToast';

const StyledInlineToast = styled(InlineToast)`
    background-color: #fef8e5;
    padding-right: 10px;
    border-radius: 8px;
`;

const IconContainer = styled(Icon)`
    height: 2rem !important;
    width: 2rem;
    margin: 1rem 1rem 0;
`;

const UpgradeLink = styled(Link)`
    color: ${({ theme }) => theme.colors.primary.main};
    cursor: pointer;
    font-weight: 700;
`;

interface Props {
    show: boolean;
}
const PRICING_QUERY_PARAM_SOURCE = 'studio-tts';

export const PremiumInlineToast = ({ show }: Props) => {
    const mixpanel = useAnalytics();
    const [showUpgradeModal, setShowUpgradeModal] = useState(false);

    const upgradeClick = useCallback(() => {
        mixpanel?.track('upgrade', {
            from: 'pro-voice',
            event: 'click',
        });
        // setShowUpgradeModal(true);
        window.open(`${pricingPageUrl}/?utm_source=${PRICING_QUERY_PARAM_SOURCE}`);
    }, [mixpanel]);

    useEffect(() => {
        if (show) {
            mixpanel?.track('upgrade', {
                from: 'pro-voice',
                event: 'view',
            });
        }
    }, [show]);

    return (
        <StyledInlineToast
            show={show}
            icon={
                <IconContainer>
                    <MaskedIcon color="#fbb701" size="2rem" src={Crown} />
                </IconContainer>
            }
            title={`You’re using a premium voice`}
            content={
                <>
                    <UpgradeLink onClick={upgradeClick}>Upgrade</UpgradeLink> to a higher plan to use our super realistic premium voices
                    <UpgradePlanModal
                        open={showUpgradeModal}
                        onClose={() => setShowUpgradeModal(false)}
                        title={<div>You picked a PRO+ voice</div>}
                        imageFile={voicePremiumUpgrade}
                        from="pro-voice"
                    />
                </>
            }
        />
    );
};
